import axios from 'axios';
import appConfig from 'configs/app.config';
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant';
import { PERSIST_STORE_NAME } from 'constants/app.constant';
import deepParseJson from 'utils/deepParseJson';
import store from '../store';
import { onSignOutSuccess } from '../store/auth/sessionSlice';

const unauthorizedCode = [401];

const baseURL = process.env.REACT_APP_SERVICE_API 
  ? `${process.env.REACT_APP_SERVICE_API}${appConfig.apiPrefix}`
  : appConfig.apiPrefix;

console.log('🔷 BaseService - baseURL configurado:', baseURL);
console.log('🔷 BaseService - REACT_APP_SERVICE_API:', process.env.REACT_APP_SERVICE_API);
console.log('🔷 BaseService - appConfig.apiPrefix:', appConfig.apiPrefix);

const BaseService = axios.create({
  timeout: 60000,
  baseURL,
});

BaseService.interceptors.request.use(
  (config) => {
    console.log('🔷 BaseService.interceptors.request - INÍCIO');
    console.log('🔷 BaseService.interceptors.request - config.baseURL:', config?.baseURL);
    console.log('🔷 BaseService.interceptors.request - config.url:', config?.url);
    console.log('🔷 BaseService.interceptors.request - URL completa:', `${config?.baseURL}${config?.url}`);
    console.log('🔷 BaseService.interceptors.request - config.method:', config?.method);
    console.log('🔷 BaseService.interceptors.request - config.data:', config?.data);
    
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);

    let accessToken = persistData.auth.session.token;

    if (!accessToken) {
      const { auth } = store.getState();
      accessToken = auth.session.token;
    }

    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
      console.log('🔷 BaseService.interceptors.request - Token adicionado');
    } else {
      console.log('🔷 BaseService.interceptors.request - Sem token');
    }

    console.log('🔷 BaseService.interceptors.request - Retornando config');
    return config;
  },
  (error) => {
    console.log('🔴 BaseService.interceptors.request - ERRO:', error);
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => {
    console.log('🔶 BaseService.interceptors.response - SUCESSO');
    console.log('🔶 BaseService.interceptors.response - response.status:', response?.status);
    console.log('🔶 BaseService.interceptors.response - response.data:', response?.data);
    console.log('🔶 BaseService.interceptors.response - Retornando response');
    return response;
  },
  (error) => {
    console.log('🔴 BaseService.interceptors.response - ERRO');
    const { response } = error;
    console.log('🔴 BaseService.interceptors.response - error.response:', response);
    console.log('🔴 BaseService.interceptors.response - error.response?.status:', response?.status);
    console.log('🔴 BaseService.interceptors.response - error.response?.data:', response?.data);

    if (response && unauthorizedCode.includes(response.status)) {
      console.log('🔴 BaseService.interceptors.response - Status 401, despachando signOut');
      store.dispatch(onSignOutSuccess());
    }

    console.log('🔴 BaseService.interceptors.response - Rejeitando promise');
    return Promise.reject(error);
  }
);

export default BaseService;
